import {ApolloLink, Observable} from '@apollo/client';
import {MISSING_FIELD_ERROR_CODE} from 'src/internal/revamp/graphql/GqlError';
import {extractTopLevelFieldNameData} from 'src/internal/revamp/queryUtils/extractTopLevelFieldNameData';

import type {FetchResult} from '@apollo/client';
import type {GraphQLError} from 'graphql';
import type {InternalOperation} from 'src/internal/revamp/apollo/types';
import type {
  GqlError,
  MissingFieldErrorExtensions,
} from 'src/internal/revamp/graphql/GqlError';

export function createMissingSchemaLink() {
  return new ApolloLink(function missingSchemaTerminatingLink(
    operation: InternalOperation,
  ) {
    const topLevelFieldNameData = extractTopLevelFieldNameData(operation.query);

    // Generate an error for each top-level field
    const errors: ReadonlyArray<GqlError> = topLevelFieldNameData.map(
      ({name, alias}) => {
        const missingFieldErrorExtensions: {
          actionId: null;
          traceId: null;
          unstable_requestId: null;
          error: MissingFieldErrorExtensions;
        } = {
          actionId: null,
          traceId: null,
          unstable_requestId: null,
          error: {
            code: MISSING_FIELD_ERROR_CODE,
            topLevelField: name,
            // Mimicking backend behavior
            status: 200,
          },
        };

        return {
          message: `Field ${name} was not found in any schema. Please make sure to declare your schemas and their fields correctly in your DataProvider`,
          path: alias ? [alias] : [name],
          extensions: missingFieldErrorExtensions,
        };
      },
    );

    // Return the response as an Observable
    return new Observable<FetchResult>((observer) => {
      observer.next({
        data: null,
        errors: errors as unknown as ReadonlyArray<GraphQLError>,
      });
      observer.complete();
    });
  });
}
